import { AppIntegrationsRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Util from 'common/services/util/-RFC.util';

/**
* @ngdoc service
* @name notifications.ActivationCodeNotifications
*
* @description
* This class is used to process notifications on activation code.
*/
const ActivationCodeNotifications = {

    getAppNameByActivationCode(activationCode) {

        const appId = Util.deepFind(activationCode, 'relationships.app.data.id');
        const appIntegration = AppIntegrationsRepository.getById(appId);
        const appName = Util.deepFind(appIntegration, 'attributes.resource.oeName');

        return appName;

    },

    /**
   * @ngdoc function
   * @name notifications.ActivationCodeNotifications#processCreate
   * @methodOf notifications.ActivationCodeNotifications
   * @function
   *
   * @description
   * This function can be used to process a new activation code.
   *
   * @param {object} data an activationCode.
   */
    processCreate(data) {

        const appName = this.getAppNameByActivationCode(data);

        Alert.success({
            message: 'cw.subscription.activation_success_desc',
        }, {
            message: {
                appName,
            },
        });

    },

    /**
     * @ngdoc function
     * @name notifications.ActivationCodeNotifications#processUpdate
     * @methodOf notifications.ActivationCodeNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on an activation code.
     *
     * @param {object} data An object with updated values on activation code.
     * @param {object} prevDevice The old activation code object.
     * @param {object} newDevice The update activation code object.
     */
    processUpdate(data, prevActivationCode, newActivationCode) {

        // Subscription turned on
        if (data['attributes.subscription'] === '1') {

            Alert.success('cw.subscription.on_success');

        }

        // Subscription turned off
        if (data['attributes.subscription'] === '0') {

            Alert.success('cw.subscription.off');

        }

        // Subscription used/activated
        if (data['attributes.status'] === 'used') {

            const appName = this.getAppNameByActivationCode(newActivationCode);

            Alert.success({
                message: 'cw.subscription.activation_success_desc',
            }, {
                message: {
                    appName,
                },
            });

        }

    },

};

export default ActivationCodeNotifications;



// WEBPACK FOOTER //
// ./scripts/common/notifications/-RFC.activationCodeNotifications.js